import {
	StoryProgress,
	ProgressSegment,
	ProgressFill,
} from '../../StoryViewer.styles';

const StoryViewerProgress = ({
	segmentCount,
	currentSegment,
	segmentProgress,
}) => (
	<StoryProgress>
		{Array.from({ length: segmentCount }).map((_, index) => {
			let width = 0;
			if (index < currentSegment) {
				width = 100;
			}
			if (index === currentSegment) {
				width = segmentProgress;
			}

			return (
				<ProgressSegment key={index}>
					<ProgressFill $width={width} />
				</ProgressSegment>
			);
		})}
	</StoryProgress>
);

export default StoryViewerProgress;
